import { getAttachmentKind, getAttachmentTypeLabel } from '../dmAttachmentKind';
import { findAttachmentRule } from './attachmentRules';

export type AttachmentIconKind = 'image' | 'video' | 'pdf' | 'file';

export function attachmentIconKind(mimeType: string): AttachmentIconKind {
    const rule = findAttachmentRule(mimeType);
    if (rule) return rule.kind;
    const kind = getAttachmentKind(mimeType);
    return kind === 'image' || kind === 'video' ? kind : 'file';
}

export function attachmentTypeLabel(mimeType: string): string {
    return findAttachmentRule(mimeType)?.label ?? getAttachmentTypeLabel(mimeType);
}
